import { DeliveryStatus } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { LeafIcon } from '@synergy/theme-next';
import {
    PoolActionLabel,
    PoolCardActionContainer,
    PoolCardHeader,
    PoolCardQuickActions,
    PoolImage,
} from '@synergy/components-next';
import { ReactElement } from 'react';
import { Stack, Tooltip, styled } from '@mui/material';

import { ArticleCardFavoriteButton } from '../components/article-card-favorite-button';
import { ArticlePlaceholderImage } from '../../article-placeholder-image/article-placeholder-image';
import { useArticleCardContext } from '../article-card';

const ProductImage = styled(PoolImage)(() => ({
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    objectFit: 'contain',
    height: 255,
    width: '100%',
}));

export const ArticleCardHeader = (): ReactElement => {
    const { article } = useArticleCardContext();

    return (
        <PoolCardHeader>
            {article.previewImage?.['270x270'] ? (
                <ProductImage src={article.previewImage['270x270']} alt={article.name} />
            ) : (
                <ArticlePlaceholderImage supplier={article.supplier} imageCachePath="270x270" height={255} />
            )}

            {article.deliveryStatus !== DeliveryStatus.OnRequest &&
                (article.isBestPrice || !!article.currentSpecialPrice || article.isEcoProduct) && (
                    <PoolCardActionContainer>
                        {article.isBestPrice && (
                            <PoolActionLabel color="secondary">
                                <FormattedMessage id="app.article.bestPrice" />
                            </PoolActionLabel>
                        )}
                        {!!article.currentSpecialPrice && (
                            <PoolActionLabel color="error">
                                <FormattedMessage id="app.article.specialPrice" />
                            </PoolActionLabel>
                        )}
                        {article.isEcoProduct && (
                            <Tooltip title={<FormattedMessage id="app.tooltip.ecoProduct" />}>
                                <Stack>
                                    <PoolActionLabel color="success">
                                        <LeafIcon />
                                    </PoolActionLabel>
                                </Stack>
                            </Tooltip>
                        )}
                    </PoolCardActionContainer>
                )}

            <PoolCardQuickActions>
                <ArticleCardFavoriteButton />
            </PoolCardQuickActions>
        </PoolCardHeader>
    );
};
